import { useAuth } from 'react-oidc-context';
import Tabs from '../components/Tabs';
import { TabItem } from '../interface/interface';
import AdminOrders from './AdminOrders';
import Reports from './Reports';
import RequestOrders from './RequestOrders';
import { useContext } from 'react';
import { UserContext } from '../context/userContext';

export function AdminOrderTabs() {
  const { user } = useAuth();
  const { requestPending } = useContext(UserContext);

  const tabs: TabItem[] = [];

  if (
    (user?.profile.groups as string[]).includes('Admin') ||
    (user?.profile.groups as string[]).includes('PLO')
  ) {
    tabs.push({ id: 'tab1', label: 'Orders', component: <AdminOrders /> });
    tabs.push({
      id: 'tab2',
      label: 'Cancellation Requests',
      component: <RequestOrders />,
      indicator: requestPending.cancelOrderRequested,
    });
    tabs.push({ id: 'tab3', label: 'Reports', component: <Reports /> });
  } else {
    tabs.push({ id: 'tab1', label: 'Orders', component: <AdminOrders /> });
    tabs.push({ id: 'tab3', label: 'Reports', component: <Reports /> });
  }

  return <Tabs tabs={tabs} />;
}
